/**
 * @fileoverview POST handler for the "/generative_ai/brand_guideline_document" endpoint
 */
import fetch from "@lib/fetch";

import { buildFetchRequestArgs } from "../formData";
import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { postGenerativeAiBrandGuidelineDocumentCacheKeys } from "./constants";
import type {
  BrandGuidelineDocumentRequestError,
  PostGenerativeAiBrandGuidelineDocumentProps,
  PostGenerativeAiBrandGuidelineDocumentResult,
} from "./types";

export const postGenerativeAiBrandGuidelineDocument = reactQueryMutationAdapter(
  postGenerativeAiBrandGuidelineDocumentCacheKeys,
  createMutationFetcherFunctionWithShadowError<BrandGuidelineDocumentRequestError>()(
    ({
      guidelineId,
      file,
    }: PostGenerativeAiBrandGuidelineDocumentProps): Promise<PostGenerativeAiBrandGuidelineDocumentResult> => {
      // Always multipart: the backend reads the upload from params[:file] via Paperclip.
      const { params, options, setContentType } = buildFetchRequestArgs(
        { guideline_id: guidelineId },
        file,
        "file"
      );

      return fetch("/generative_ai/brand_guideline_document", "POST", params, options, {
        setContentType,
        propagateFetchRequestError: false,
      });
    }
  )
);
